import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";

import { HTTPError, post } from "../helpers/HTTP";

import type { AgencyPlan, Promotion } from "../types";

async function createSubscriptionRequest(
  count: number,
  paymentSourceId: string,
  planPricingId: string,
): Promise<AgencyPlan> {
  return (
    await post(`subscriptions`, {
      seat_count: count,
      payment_source_id: paymentSourceId,
      item_price_id: planPricingId,
    })
  ).promotion;
}

export default function useCustomerSubscriptionMutations() {
  const queryClient = useQueryClient();

  const { mutateAsync: createSubscription, isPending: isCreatingSubscription } =
    useMutation({
      mutationFn: ({
        count,
        paymentSourceId,
        planPricingId,
      }: {
        count: number;
        paymentSourceId: string;
        planPricingId: string;
      }) => createSubscriptionRequest(count, paymentSourceId, planPricingId),
      onSuccess: (promotion) => {
        queryClient.setQueryData<Promotion[]>(
          ["promotions"],
          (prevPromotions) => {
            if (prevPromotions) {
              return [...prevPromotions, promotion];
            } else {
              return [promotion];
            }
          },
        );

        toast.success("Subscription created");
      },
      onError: (error) =>
        toast.error(
          error instanceof HTTPError && error.serverMessage
            ? error.serverMessage
            : "Failed to create subscription",
        ),
    });

  return {
    createSubscription,
    isCreatingSubscription,
  };
}
